import React from 'react'
import { connect } from 'react-redux'
import * as actions from '../store/actions'
import DaneIdentyfikacyjne from '../containers/sections/DaneIdentyfikacyjne'
import DaneOrganizacyjne from '../containers/sections/DaneOrganizacyjne'
import InformacjeDodatkoweSkonsolidowane from '../containers/sections/InformacjeDodatkoweSkonsolidowane'
import InformacjeDodatkoweSkonsolidowaneV12 from '../containers/sections/InformacjeDodatkoweSkonsolidowaneV12'
import InformacjeUszczegolawiajace from '../containers/sections/InformacjeUszczegolawiajace'
import KryteriaKonsolidacji from '../containers/sections/KryteriaKonsolidacji'
import OkresSprawozdawczy from '../containers/sections/OkresSprawozdawczy'
import RachunekPrzeplywow from '../containers/sections/RachunekPrzeplywow'
import RoznicaCITRZiS from '../containers/sections/RoznicaCITRZiS'
import RZiS from '../containers/sections/RZiS'
import Bilans from '../containers/sections/Bilans'
import SkonsolidowaneDaneOrganizacyjne from '../containers/sections/SkonsolidowaneDaneOrganizacyjne'
import Walidacja from '../containers/sections/Walidacja'
import WykazCzasuTrwania from '../containers/sections/WykazCzasuTrwania'
import WykazJednostekInnych from '../containers/sections/WykazJednostekInnych'
import WykazJednostekObjetychSprFin from '../containers/sections/WykazJednostekObjetychSprFin'
import WykazJednostekWylaczonych from '../containers/sections/WykazJednostekWylaczonych'
import Zalaczniki from '../containers/sections/Zalaczniki'
import ZasadyRachunkowosci from '../containers/sections/ZasadyRachunkowosci'
import ZestawienieZmianWKapitale from '../containers/sections/ZestawienieZmianWKapitale'
import ZmianyPolitykiRachunkowosci from '../containers/sections/ZmianyPolitykiRachunkowosci'
import PozycjePozabilansowe from '../containers/sections/PozycjePozabilansowe'
import RachunekPrzeplywowDomMaklerski from '../containers/sections/RachunekPrzeplywowDomMaklerski'
import Wydruk from '../containers/sections/Wydruk'

class TypSekcji extends React.Component {
  getSection(sectionList, section, onSetSectionDataArray) {
    return (() => {
      switch (section.TypSekcji) {
        case 'IdentyfikacjaPodmiotu':
        case 'IdentyfikacjaPodmiotu_v1_2':
        case 'IdentyfikacjaPodmiotuKultury_v1_2':
        case 'IdentyfikacjaPodmiotuSkrocona':
        case 'IdentyfikacjaPodmiotuSkrocona_v1_2':
        case 'IdentyfikacjaDomuMaklerskiego':
        case 'IdentyfikacjaDomuMaklerskiego_v1_2':
        case 'InformacjeJednostkaDominujaca':
        case 'InformacjeJednostkaDominujaca_v1_2':
          return <DaneIdentyfikacyjne sectionList={sectionList} />
        case 'OkresSprawozdania':
          return <DaneOrganizacyjne sectionList={sectionList} />
        case 'WewnetrzneJednostki':
          return <SkonsolidowaneDaneOrganizacyjne sectionList={sectionList} />
        case 'PolitykaRachunkowosci':
        case 'PolitykaRachunkowosciSkrocona':
        case 'PolitykaRachunkowosciSkonsolidowana':
        case 'PolitykaRachunkowosciSkonsolidowana_v1_2':
        case 'PolitykaRachunkowosci_v1_2':
          return <ZasadyRachunkowosci sectionList={sectionList} />
        case 'ZmianyPolitykiRachunkowosci':
          return <ZmianyPolitykiRachunkowosci section={section} />
        case 'InformacjeSzczegolowe':
          return <InformacjeUszczegolawiajace section={section} />
        case 'WykazJednostekObjetychSprFin':
          return <WykazJednostekObjetychSprFin section={section} />
        case 'OpisKryteriowObjeciaSprFin':
          return <KryteriaKonsolidacji sectionList={sectionList} />
        case 'WykazJednostekInnych':
          return <WykazJednostekInnych section={section} />
        case 'WykazJednostekWylaczonych':
          return <WykazJednostekWylaczonych section={section} />
        case 'WykazCzasuTrwania':
          return <WykazCzasuTrwania section={section} />
        case 'OkresSprawozdaniaSkrocona':
          return <OkresSprawozdawczy sectionList={sectionList} />
        case 'Bilans':
          return <Bilans section={section} />
        case 'PozycjePozabilansowe':
          return <PozycjePozabilansowe section={section} />
        case 'RZIS':
          return <RZiS section={section} />
        case 'ZestawienieZmianWKapitale':
        case 'ZestawienieZmianWKapitale_v1_3':
        case 'ZestawienieZmianWKapitaleDomMaklerski':
        case 'SkonsolidowaneZestawienieZmianWKapitale':
        case 'SkonsolidowaneZestawienieZmianWKapitale_v1_3':
            return <ZestawienieZmianWKapitale section={section} />
        case 'RachunekPrzeplywowPienieznych':
        case 'SkonsolidowanyRachunekPrzeplywowPienieznych':
          return <RachunekPrzeplywow section={section} />
        case 'RachunekPrzeplywowPienieznych_v1_2':
        case 'RachunekPrzeplywowPienieznych_v1_3':
        case 'SkonsolidowanyRachunekPrzeplywowPienieznych_v1_2':
        case 'SkonsolidowanyRachunekPrzeplywowPienieznych_v1_3':
            return <RachunekPrzeplywow section={section} czyPolaBezKwot={true} />
        case 'RachunekPrzeplywowDomMaklerski':
          return <RachunekPrzeplywowDomMaklerski section={section} />
        case 'Zalaczniki':
          return (
            <Zalaczniki
              zalaczniki={section.Dane.Pozycje}
              onSetSectionDataArray={onSetSectionDataArray}
            />
          )
        case 'InformacjaDodatkowaPodatekDochodowy':
        case 'InformacjaDodatkowaPodatekDochodowyOpcjonalna':
          return <RoznicaCITRZiS section={section} sectionList={sectionList} />
        case 'InformacjeDodatkoweSkonsolidowane':
          return (
            <InformacjeDodatkoweSkonsolidowane
              section={section}
              sectionList={sectionList}
            />
          )
        case 'InformacjeDodatkoweSkonsolidowane_v1_2':
          return (
            <InformacjeDodatkoweSkonsolidowaneV12
              section={section}
              sectionList={sectionList}
            />
          )
        case 'Walidacja':
          return <Walidacja />
        default:
          return null
      }
    })()
  }

  getPodsumowanie(sectionList, menu) {
    return (
      <>
        {sectionList.map(item => {
          if (
            menu.some(
              m => m.Sekcje.length > 0 && m.Sekcje[0] === item.TypSekcji,
            )
          ) {
            return (
              <Wydruk key={item.TypSekcji}>
                {this.getSection(sectionList, item)}
              </Wydruk>
            )
          } else if (
            menu.some(
              m =>
                m.Dzieci.length > 0 &&
                m.Dzieci.some(d => d.Sekcje[0] === item.TypSekcji),
            )
          ) {
            return (
              <Wydruk key={item.TypSekcji}>
                {this.getSection(sectionList, item)}
              </Wydruk>
            )
          }
          return null
        })}
      </>
    )
  }

  render() {
    const {
      sectionList,
      czyPodsumowanie,
      onSetSectionDataArray,
      menu,
    } = this.props
    if (czyPodsumowanie) return this.getPodsumowanie(sectionList, menu)
    return this.getSection(sectionList, sectionList[0], onSetSectionDataArray)
  }
}

const mapStateToProps = state => {
  return {
    menu: state.sprawozdanie.header.Menu,
  }
}

const mapDispatchToProps = dispatch => ({
  onSetSectionDataArray: (v, i, n) =>
    dispatch(actions.setSectionDataArray(v, i, 0, n)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TypSekcji)
